import { useParams as _useParams } from 'react-router-dom';

type Params = {
  id: string;
  taskId: string;
  subTaskId?: string;
};

export const useParams = () => {
  return _useParams<Params>() as Params;
};
